import { render, staticRenderFns } from "./m3u8VideoH265.vue?vue&type=template&id=7f15827b&scoped=true"
import script from "./m3u8VideoH265.vue?vue&type=script&lang=js"
export * from "./m3u8VideoH265.vue?vue&type=script&lang=js"
import style0 from "./m3u8VideoH265.vue?vue&type=style&index=0&id=7f15827b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f15827b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f15827b')) {
      api.createRecord('7f15827b', component.options)
    } else {
      api.reload('7f15827b', component.options)
    }
    module.hot.accept("./m3u8VideoH265.vue?vue&type=template&id=7f15827b&scoped=true", function () {
      api.rerender('7f15827b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/m3u8VideoH265.vue"
export default component.exports